import React, { FC } from "react";
import { VictoryPie } from "./chart";
import { wpdColor } from "../../styles/theme";
import styled from "styled-components/native";

const PieWrapper = styled.View`
  width: 100%;
  display: flex;
  align-items: center;
`;

const PieWrapperInner = styled.View`
  max-width: 300px;
  padding-left: 20px;
  padding-right: 20px;
`;

interface PieProps {
  data: any[];
}

const PadAngle: FC<PieProps> = ({ data }) => {
  return (
    <PieWrapper>
      <PieWrapperInner>
        <VictoryPie
          colorScale={[
            wpdColor.primary,
            wpdColor.quaternary,
            wpdColor.secondary,
            wpdColor.tertiary,
            wpdColor.quinary,
          ]}
          padAngle={0}
          innerRadius={115}
          labels={() => null}
          data={data.slice(0, 5)}
        />
      </PieWrapperInner>
    </PieWrapper>
  );
};

export default PadAngle;
